// Default brand: the multi-tenant app, every tenant customizes itself from the backend.
// A brand build (REACT_APP_BRAND=<brand>) replaces this file with src/brands/<brand>/brand/config.js (see craco.config.js).
const config = {
  name: '',           // brand name, used as the logo alt
  appName: null,      // web app name (tab title, PWA): wins over the tenant one. Brands take it from brand/meta.json, also used by craco for the html link preview
  logo: null,         // static logo: wins over the tenant one
  icon: null,         // web app icon (favicon, home screen, PWA): wins over the tenant one
  splash: null,       // splash image (assets/splash.png): the app opening loader looks like the native splash
  splashColor: null,  // splash background color, shown while the image loads
  theme: null,        // static personalizations: win over the tenant ones
  strings: {},        // per language ({ it, en }): translations merged over src/services/i18n/lang/<lang>.json
  fontsUrl: null,     // stylesheet with the brand fonts
  loginIntro: false,  // login side panel (desktop) and micro onboarding (mobile)
  supportByTf: false, // "support managed by thefaculty" note with the logo, in the contact section
  tfAppSignup: true,  // OFA: users sign up on the thefaculty app (login and waiting screens point there)
}

export default config
